import { site, categories } from "@/mocks/heigua";

const navLinks = [
  { label: "档案检索", href: "#library" },
  { label: "年份时间线", href: "#timeline" },
  { label: "旧料精选", href: "#featured" },
  { label: "经典合集", href: "#collections" },
  { label: "深度回顾", href: "#deep" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Footer() {
  const catList = categories.slice(1);
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-archive-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {site.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300/90">
              {site.desc}
            </p>
            <p className="mt-4 inline-flex items-center gap-1.5 text-xs text-accent-300">
              <i className="ri-time-line" />
              {site.slogan}
            </p>
          </div>

          <nav aria-label="页脚导航">
            <p className="text-xs font-semibold tracking-widest uppercase text-accent-300">
              快速跳转
            </p>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-background-200/90 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容分类">
            <p className="text-xs font-semibold tracking-widest uppercase text-accent-300">
              内容分类
            </p>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {catList.map((c) => (
                <li key={c.key}>
                  <a
                    href="#library"
                    className="text-sm text-background-200/90 transition-colors hover:text-accent-300"
                  >
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="text-xs font-semibold tracking-widest uppercase text-accent-300">
              栏目简介
            </p>
            <p className="mt-4 text-sm leading-relaxed text-background-300/90">
              本站专注黑瓜旧瓜考古与历史回顾，把往期整理、经典合集与陈年旧料按时间归档，方便你补瓜、追脉络、翻老料。
            </p>
            <a
              href="#start"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200/25 px-4 py-2 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-arrow-up-line" />
              回到顶部
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-300/80">
            © {new Date().getFullYear()} {site.name} · 旧料归档 · 谨慎考证
          </p>
          <p className="text-xs text-background-300/60">
            内容仅供历史回顾与信息整理，请以公开权威信息为准
          </p>
        </div>
      </div>
    </footer>
  );
}